import { render, staticRenderFns } from "./Purchases.vue?vue&type=template&id=1e17d5b6"
import script from "./Purchases.vue?vue&type=script&lang=js"
export * from "./Purchases.vue?vue&type=script&lang=js"
import style0 from "./Purchases.vue?vue&type=style&index=0&id=1e17d5b6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports